import { isFeatureEnabled } from 'stores/features-list-store';
import { isSharedAccount } from 'stores/user-store';
import { restrictions } from 'state/features-list/constants';

export const shouldGrantAccessToWpoAppointmentsFlow = async () => {
  if (isSharedAccount()) {
    return { provideAccess: false, redirectTo: 'limitedAccount' };
  }

  return isFeatureEnabled(restrictions.wpo_online_scheduling)
    ? { provideAccess: true, redirectTo: '' }
    : { provideAccess: false, redirectTo: 'pageNotFound' };
};

type CounsellorNameProps = {
  firstName?: string | null;
  lastName?: string | null;
};

export const getCounsellorFirstNameLastInitial = ({
  firstName,
  lastName,
}: CounsellorNameProps): string | null => {
  if (!firstName) return lastName || null;
  const lastInitial = (lastName || '').charAt(0);
  return lastInitial ? `${firstName} ${lastInitial}.` : firstName;
};

export const getWpoCounsellorShortName = (counsellorName: string): string => {
  const words = counsellorName.trim().split(/\s+/).filter(Boolean);
  const first = (words[0] ?? '').charAt(0);
  const last = words.length > 1 ? (words.at(-1) ?? '').charAt(0) : '';
  return `${first}${last}`.toUpperCase();
};
